import React, { useState, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import axios from "axios";
import "./AdmissionList.css";
import { DEFAULT_SESSION, SESSION_OPTIONS } from "../../../constants/sessions";

const AdmissionList = () => {
  const [students, setStudents] = useState([]); // Ensure it's initialized as an empty array
  const [selectedSession, setSelectedSession] = useState(DEFAULT_SESSION);
  useEffect(() => {
    const fetchStudents = async () => {
      try {
        // Assuming the backend has an endpoint that accepts the session in the request body
        const token = JSON.parse(localStorage.getItem("token"));
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/api/students`,
          { session: selectedSession },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        // Check if the response is an array
        if (Array.isArray(response.data)) {
          setStudents(response.data); // Set students data from backend
          if (response.data.length === 0) {
            toast.info("No students found for this session.");
          }
        }
      } catch (error) {
        toast.error("Error fetching student data");
      }
    };

    if (selectedSession) {
      fetchStudents();
    }
  }, [selectedSession]);

  const handleSessionChange = (event) => {
    setSelectedSession(event.target.value);
  };

  const filteredStudents = students.filter(
    (student) => student.session === selectedSession
  );

  const handleDelete = async (studentId) => {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}/api/student/${studentId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        // Remove the deleted student from the local state
        const updatedStudents = students.filter(
          (student) => student.student_id !== studentId
        );
        setStudents(updatedStudents);
        toast.success("Student deleted successfully!");
      }
    } catch (error) {
      toast.error("Error deleting student");
    }
  };

  return (
    <div className="container mt-5 bg-white rounded p-5 mb-5">
      <div className="row mb-3 d-flex justify-content-between align-items-center">
        {/* Back Button */}
        <div className="col-auto">
          <Link to="/erp/admissions" className="btn btn-secondary">
            &#8592; Back to Admissions
          </Link>
        </div>

        {/* Centered Heading */}
        <div className="col-auto text-center">
          <h3 className="text-success">Student Admission List</h3>
        </div>
      </div>

      <div className="row mb-4 d-flex justify-content-center align-items-center">
        <div className="col-md-3 text-center">
          <label htmlFor="sessionSelect" className="form-label">
            Select Session:
          </label>
          <select
            id="sessionSelect"
            className="form-select"
            value={selectedSession}
            onChange={handleSessionChange}
          >
            {SESSION_OPTIONS.map((session) => (
              <option key={session} value={session}>
                {session}
              </option>
            ))}
          </select>
        </div>
      </div>

      {selectedSession && students.length != 0 && (
        <div className="table-responsive">
          <table className="table table-striped table-hover table-bordered  text-center">
            <thead className="table-dark">
              <tr>
                <th>#</th>
                <th>Student Name</th>
                <th>Student ID</th>
                <th>Class</th>
                <th>Session</th>
                <th>Fees Paid</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredStudents.map((student, index) => (
                <tr key={student.id}>
                  <td>{index + 1}</td>
                  <td>{student.student_name}</td>
                  <td>{student.student_id}</td>
                  <td>{student.student_class}</td>
                  <td>{student.session}</td>
                  <td>
                    <span
                      className={`badge ${
                        student.admission_fees_paid ? "bg-success" : "bg-danger"
                      }`}
                    >
                      {student.admission_fees_paid ? "Paid" : "Pending"}
                    </span>
                  </td>
                  <td className="text-center">
                    {/* <Link
                      to={`/student/update/${student.student_id}`}
                      style={{ textDecoration: "none", color: "white" }}
                    >
                      <button className="btn btn-primary btn-sm me-2">
                        Update
                      </button>
                    </Link> */}
                    {!student.admission_fees_paid && (
                      <span>
                        <Link
                          to={`/erp/fees/payment/${student.student_id}?type=other_fee&fee_name=Admission Fee`}
                        >
                          <button className="btn btn-warning btn-sm me-2 actions-btn-admissions">
                            Pay Admission Fees
                          </button>
                        </Link>

                        <button
                          type="button"
                          className="btn btn-danger btn-sm actions-btn-delete"
                          data-bs-toggle="modal"
                          data-bs-target="#deleteModal1"
                        >
                          Delete Student
                        </button>

                        <div
                          className="modal fade"
                          id="deleteModal1"
                          tabIndex="-1"
                          aria-labelledby="exampleModalLabel1"
                          aria-hidden="true"
                        >
                          <div className="modal-dialog">
                            <div className="modal-content">
                              <div className="modal-header">
                                <h1
                                  className="modal-title fs-5"
                                  id="exampleModalLabel1"
                                >
                                  Confirm Deletion
                                </h1>
                                <button
                                  type="button"
                                  className="btn-close"
                                  data-bs-dismiss="modal"
                                  aria-label="Close"
                                ></button>
                              </div>
                              <div className="modal-body text-start">
                                Do you want to delete the student detail ?
                              </div>
                              <div className="modal-footer">
                                <button
                                  type="button"
                                  className="btn btn-secondary"
                                  data-bs-dismiss="modal"
                                >
                                  Close
                                </button>
                                <button
                                  type="button"
                                  onClick={() =>
                                    handleDelete(student.student_id)
                                  }
                                  className="btn btn-danger"
                                  data-bs-dismiss="modal"
                                >
                                  Delete Student
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </span>
                    )}
                    {student.admission_fees_paid && (
                      <span>
                        <Link
                          to={`/erp/fee-receipt/${student.student_id}?type=other_fee&fee_name=Admission Fee`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <button className="btn btn-success btn-sm me-2 btn-fee-receipt">
                            Fee Receipt
                          </button>
                        </Link>
                        <Link
                          to={`/erp/admission-slip/${student.student_id}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <button className="btn btn-success btn-sm">
                            Admission Slip
                          </button>
                        </Link>
                      </span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <ToastContainer />
    </div>
  );
};

export default AdmissionList;
